// extracted by mini-css-extract-plugin
export default {"modalContent":"UploadProductsFeedsModal_modalContent__sYs33","icon":"UploadProductsFeedsModal_icon__8z00Y"};